// extracted by mini-css-extract-plugin
module.exports = {"globalHeader":"overlay__globalHeader--4GwjS","divider":"overlay__divider--2wPr2"};
    if(module.hot) {
      // 1545480328909
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  